<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--    협의체 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>협의체 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>회의일</div>
          <span v-if="isPrint" class="print-input"> {{ form.회의일 }} </span>
          <date-selector v-else v-model="form.회의일" :readonly="board.readonly" />
        </div>
        <div>
          <div>시간</div>
          <p v-if="isPrint" class="print-input">{{ form.회의시간_시작 }} ~ {{ form.회의시간_종료 }}</p>
          <div v-else class="time">
            <time-selector v-model="form.회의시간_시작" :readonly="board.readonly" />
            ~
            <time-selector v-model="form.회의시간_종료" :readonly="board.readonly" />
          </div>
        </div>

        <div class="writeGridLineItem">
          <div>참석자</div>
          <p v-if="isPrint" class="print-textarea">{{ form.참석자 }}</p>
          <ml-textarea v-else rows="3" v-model="form.참석자" :readonly="board.readonly" :max="1000" />
        </div>
        <div class="writeGridLineItem">
          <div>협의주제</div>
          <p v-if="isPrint" class="print-textarea">{{ form.협의주제 }}</p>
          <ml-textarea v-else rows="5" v-model="form.협의주제" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>금회 회의내용</div>
          <p v-if="isPrint" class="print-textarea">{{ form.회의내용 }}</p>
          <ml-textarea v-else rows="5" v-model="form.회의내용" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import TableRiskAssemblyRecord from "@/components/TableRiskAssemblyRecord.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    DisasterClassSelector,
    TableRiskAssemblyRecord,
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        회의일: '',
        회의시간_시작: '',
        회의시간_종료: '',
        참석자: '',
        협의주제: '',
        회의내용: '',
      },
    };
  },
};
</script>
